<script>
import Step from 'element-ui/lib/step';

export default Step;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/step.css';
// Adding RTL support to element's alert

.el-step {
  $step: &;

  &__main {
    padding: 0 $global-padding;
  }

  &__title {
    line-height: $global-lineheight * 1.2;
  }

  &.is-horizontal.is-center {
    #{$step}__line {
      left: 50%;
      right: -50%;

      @include rtl() {
        left: -50%;
        right: 50%;
      }
    }
  }
}
</style>
